module.exports = __webpack_public_path__ + "static/media/language.8cfe3210.svg";